// The backend can store a failure message instead of a real link (ex. the PDF
// generation failed), which would turn an <a href> into a relative navigation.
export const isDownloadableUrl = (value) => {
  if (typeof value !== "string" || !value.trim()) return false;

  try {
    const { protocol } = new URL(value);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
};
